import NoResultsIcon from '@/assets/icons/NoResults.svg';
import { useTranslation } from '@/i18n/client';
import styles from './index.module.scss';

export const NoResult = ({ k, text }: { k: string; text?: string }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.noResult}>
      <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <NoResultsIcon></NoResultsIcon>
      </div>
      {text ? (
        <p className={styles.k}>{text}</p>
      ) : (
        <p className={styles.k}>
          {t('s.noResult.noResultsFound')}{' '}
          {k ? (
            <>
              {t('s.noResult.for')} {`"${k}"`}
            </>
          ) : (
            ''
          )}
        </p>
      )}
    </div>
  );
};
